"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lazyWithRetry = exports.retryLazy = void 0;
const react_1 = require("react");
/**
 * Retry loading import once on failure
 * @param factory Factory that returns the import promise
 * @returns the import promise
 */
function retryLazy(factory) {
    return factory().catch((e) => {
        lazyWithRetry.logCallback('Could not load component, retrying once {error}', e);
        return factory();
    });
}
exports.retryLazy = retryLazy;
/**
 * Wrapper on `React.lazy` which will retry the import exactly once after it has failed
 * @param factory The same factory accepted by `React.lazy`
 * @throws When the 2 attempts of loading the component have failed
 * @returns The exotic component returned by `React.lazy`
 */
function lazyWithRetry(factory) {
    return (0, react_1.lazy)(() => retryLazy(factory));
}
exports.lazyWithRetry = lazyWithRetry;
/**
 * Default logCallback
 * @param message {string} the error message
 * @param error the error returned when trying to load the component
 */
lazyWithRetry.logCallback = console.warn;
//# sourceMappingURL=lazy.js.map